import { useFormatedDate } from '@common/hooks/useFormatedDate';
import { Text } from '@radix-ui/themes';

interface FormatedDateProps {
    date: number | Date;
    options?: Intl.DateTimeFormatOptions;
}

export const FormatedDate = ({ date, options }: FormatedDateProps) => {
    const { formatDate } = useFormatedDate(options);
    return <Text>{formatDate(date)}</Text>;
};
